export default __webpack_public_path__ + "static/quoteBackground-8b5774feacce35bd3901dad69178026d.svg";